import * as Sentry from '@sentry/browser';

export const sentryClient = new Sentry.BrowserClient({
  dsn: 'https://1b5cafcb7632410597094268f9de0caf@sentry.wixpress.com/221',
});
